module.exports = __webpack_public_path__ + "static/img/m3.8ffc134.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m3.jpg
// module id = t0pE
// module chunks = 1